module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clientes/detalles/components/creditos/clientes-creditos.component.scss
// module id = ./src/app/clientes/detalles/components/creditos/clientes-creditos.component.scss
// module chunks = main